<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'Edit default text' | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form novalidate (ngSubmit)="onSave()" [formGroup]="textForm">
      <div class="form-group">
        <textarea
          appSmartcodePreview
          [account]="account"
          [organization]="activeOrg"
          rows="5"
          class="form-control"
          tabindex="1"
          formControlName="value"
        ></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      {{ 'Update' | translate }}
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
